import { graphql } from "@/gql";
import { ResultOf } from "@graphql-typed-document-node/core";

export type OrganisationUserItem = ResultOf<
  typeof organisationUsersQuery
>["organisationUsers"]["data"][number];

export const organisationUsersQuery = graphql(`
  query OrganisationUsers($organisation_id: ID!, $first: Int!, $page: Int) {
    organisationUsers(
      organisation_id: $organisation_id
      first: $first
      page: $page
    ) {
      data {
        id
        user {
          id
          name
          primary_email
        }
        created_at
      }
      paginatorInfo {
        ...PaginationFields
      }
    }
  }
`);
